import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';

export default function ChartPanel({ trades, setCurrentPrice }) {
  const chartRef = useRef(null);
  const chartInstance = useRef();
  const lineSeries = useRef();
  const dataPoints = useRef([]);
  const socketRef = useRef(null);

  useEffect(() => {
    const fetchAndStart = async () => {
      const res = await fetch('https://api.binance.com/api/v3/klines?symbol=BNBUSDT&interval=1m&limit=500');
      const json = await res.json();
      const initialData = json.map(item => ({
        time: item[0] / 1000,
        value: parseFloat(item[4]),
      })).sort((a, b) => a.time - b.time); // ensure ascending order

      dataPoints.current = [...initialData];

      
  if (chartRef.current.firstChild) {
  chartRef.current.removeChild(chartRef.current.firstChild);
}
      const chart = createChart(chartRef.current, {
        layout: { background: { color: '#000' }, textColor: '#DDD' },
        grid: { vertLines: { color: '#2B2B43' }, horzLines: { color: '#363C4E' } },
        timeScale: {
          timeVisible: true,
          secondsVisible: false,
          tickMarkFormatter: (time) => {
            const date = new Date(time * 1000);
            const hrs = String(date.getHours()).padStart(2, '0');
            const mins = String(date.getMinutes()).padStart(2, '0');
            return `${hrs}:${mins}`;
          },
        },
        crosshair: { mode: 0 },
        height: chartRef.current.clientHeight || 300,
        width: chartRef.current.clientWidth || 300,
      });

      const series = chart.addLineSeries({ color: '#2962FF', lineWidth: 2 });
      series.setData(initialData);
      lineSeries.current = series;
      chartInstance.current = chart;

      if (initialData.length > 0) {
        setCurrentPrice(initialData[initialData.length - 1].value);
      }

      const socket = new WebSocket('wss://stream.binance.com:9443/ws/bnbusdt@trade');
      socketRef.current = socket;

      socket.onmessage = function (event) {
        const data = JSON.parse(event.data);
        const price = parseFloat(data.p);
        const time = Math.floor(data.T / 1000);

        const last = dataPoints.current[dataPoints.current.length - 1];
        if (last && time <= last.time) return; // ignore old trades

        setCurrentPrice(price);
        dataPoints.current.push({ time, value: price });

        if (dataPoints.current.length > 300) {
          dataPoints.current.shift();
        }

        lineSeries.current.setData([...dataPoints.current]);
      };

      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          chart.resize(width, height);
        }
      });
      resizeObserver.observe(chartRef.current);
    };

    fetchAndStart();

    return () => {
      if (socketRef.current) socketRef.current.close();
    };
  }, [setCurrentPrice]);

  useEffect(() => {
  
    if (lineSeries.current && trades.length > 0) {
      const markers = trades.map(trade => ({
        time: trade.time,
        position: trade.type === 'CALL' ? 'belowBar' : 'aboveBar',
        color: trade.type === 'CALL' ? 'green' : 'red',
        shape: trade.type === 'CALL' ? 'arrowUp' : 'arrowDown',
        text: trade.type,
      }));
      lineSeries.current.setMarkers(markers);
    }
  }, [trades]);

  return (
    <div
      ref={chartRef}
      style={{
        width: '100%',
        height: '300px',
        maxWidth: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    ></div>
  );
}